import { Tooltip } from 'antd';
import { ReactNode } from 'react';

import theme from '../../../assets/theme';
import { ProfileCircle } from '../../ProfileCircle';
import ConditionalWrapper from '../ConditionalWrapper';
const UserProfileCircle = ({
  userName,
  showHoveranimation = false,
  radius,
}: {
  userName?: string;
  showHoveranimation?: boolean;
  radius?: number;
}) => {
  return (
    <ConditionalWrapper
      condition={!!userName && userName !== '-'}
      truthyWrapper={(children: ReactNode) => (
        <Tooltip placement="top" title={userName}>
          {children}
        </Tooltip>
      )}
    >
      <ProfileCircle
        $background={'#535454'}
        $showHoverAnimation={showHoveranimation}
        $color={theme.colors.white}
        $radius={radius}
        style={{ border: `2px ${theme.colors.background} solid` }}
      >
        <span style={{ fontWeight: 'bold' }}>
          {userName?.slice(0, 1).toLocaleUpperCase()}
        </span>
      </ProfileCircle>
    </ConditionalWrapper>
  );
};
export default UserProfileCircle;
